module.exports = __webpack_public_path__ + "static/img/095_TO8_1771_og.a7673ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/095_TO8_1771_og.jpg
// module id = 4hfL
// module chunks = 0